import React from 'react';
import './SendPageHeader.css';

interface Props {
  onSearch?: (query: string) => void;
  displayMode?: 'comfortable' | 'compact';
  onDisplayModeChange?: (mode: 'comfortable' | 'compact') => void;
  initialSearchValue?: string;
}

export default function SendPageHeader({ onSearch, displayMode = 'comfortable', onDisplayModeChange, initialSearchValue = '' }: Props) {
  return (
    <div className="send-header-container">
      {/* Header Text */}
      <div className="send-header-top">
        <div className="send-header-text">
          <h2 className="send-header-title">Available Trades</h2>
          <p className="send-header-subtitle">
            These are cards wanted by community members. Initiate a trade and send cards to earn points equivalent to their value.
          </p>
        </div>
      </div>

      {/* Search & Controls */}
      <div className="send-header-controls">
        <input
          type="text"
          className="send-search-input"
          placeholder="Search username or card name"
          defaultValue={initialSearchValue}
          onChange={(e) => onSearch?.(e.target.value)}
        />
        <select 
          className="send-dropdown"
          value={displayMode}
          onChange={(e) => onDisplayModeChange?.(e.target.value as 'comfortable' | 'compact')}
        >
          <option value="comfortable">Comfortable</option>
          <option value="compact">Compact</option>
        </select>
        {/* <select className="send-dropdown">
          <option>Package Value</option>
          <option>Low to High</option>
          <option>High to Low</option>
        </select> */}
      </div>
    </div>
  );
}
